<template>
  <div id="app">
    <notifications ref="notifications"></notifications>
    <router-view/>
  </div>
</template>

<script>
  import kayak from '@/frame/kayak.js'

  export default {
    name: 'App',
    data: function () {
      return {}
    },
    created() {
      kayak.app = this;
    },
    methods:{

    }
  }
</script>

<style lang="scss">
  @import "./assets/scss/k-menu";

  body {
    padding: 0;
    margin: 0;

    .highest-priority {
      z-index: 3005 !important;
    }
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    /* -webkit-font-smoothing: antialiased; */
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    width: 100%;
    /* background-color: #3fd5be; */
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .kk-mask {
    display: none;
  }

  .new-side-bar {
    .el-dialog__wrapper {
      &:not(.design){
        z-index: 1000 !important;
      }
    }

    .kk-mask {
      position: fixed;
      right: 0;
      bottom: 0;
      width: calc(100vw - 260px);
      height: calc(100vh - 45px);
      background-color: black;
      opacity: 0.5;
      z-index: -1;
      display: block;
    }

    .v-modal {
      display: none;
      width: 0 !important;
      height: 0 !important;
      z-index: -200 !important;
      position: absolute !important;
    }

    &.sidebar-mini{
      .kk-mask{
        width: calc(100vw - 60px)
      }
    }
  }

  .top-more-menu {
    margin-top: 25px !important;
    border: none;
    background: transparent;
    box-shadow: none;
    border-radius: 0px;
    .more{
      cursor: pointer;
      width: 164px;
      margin: 0;
      list-style: none;
      background: #FFFFFF;
      box-shadow: 0px 2px 13px 0px rgba(185, 185, 185, 0.47);
      border-radius: 4px;
      color: #8A8A8A;
      font-size: 14px;
      font-weight: 400;
      padding: 2px 0;
      li {
        display: flex;
        padding: 5px 10px 5px 20px;
        margin: 2px 4px;
        border-radius: 5px;
        position: relative;

        .gou {
          display: none;
          position: absolute;
          left: 5px;
          top: 6px;
        }

        .name {
          margin-right: auto;
        }
      }

      li:hover {
        background-color: #EEEEEE;
      }

      .route-active {
        color: #060606;

        .gou{
          display: block !important;
        }
        //background-color: $color !important;
        &:hover {
          color: #303133;
          //background-color: $color !important;
        }
      }

      .fg {
        margin: 0 auto;
        padding: 0;
        width: 90%;
        height: 1px;
        background-color: #8A8A8A;
      }
    }
  }

  .k-tab-popper{
    border: 1px solid #a1a6ac !important;
    font-size: 11px !important;
    border-radius: 0px !important;
    padding: 4px 8px !important;
    font-color: rgb(4, 4, 4) !important;
    color: rgb(4, 4, 4) !important;
    margin-left: 60px !important;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue